import { useContext, useEffect } from 'react';
import LeftSidePopupLayout from './modal-layout';
import XCloseIcon from '../icons/x-close';
import Style from './style.module.css'
import { useApiCall } from '../custom-hooks/api-call';
import { GlobalContext } from '../../context/Context';
import { useFormik } from 'formik';
import * as yup from "yup";
import Select from "react-select";

const BrandModal = ({ onSubmit = () => { }, onClose = () => { }, onError = () => { }, currentList }) => {

  console.log("currentList", currentList)

  let { state } = useContext(GlobalContext);

  const apiCall = useApiCall();

  useEffect(() => {
    if (currentList?.id) {
      formik.setFieldValue("brandName", currentList?.name ?? "");
      formik.setFieldValue("url", currentList?.url ?? "");
      formik.setFieldValue("status", currentList?.is_active ?? "")
    }
  }, [])

  const validationSchema = yup.object({
    brandName: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    url: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    status: yup
      .string('This Field is Required')
      .required('This Field is Required')
  });

  const formik = useFormik({
    initialValues: {
      brandName: '',
      url: '',
      status: '1'
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {

      console.log("Values", values);

      let extraField = {};

      if(currentList?.id){
        extraField = {
          "brand_id": currentList?.id
        }
      }

      let data = {
        ...extraField,
        "name": values?.brandName,
        "brand_url": values?.url,
        "is_active": values?.status,
      }

      try {
        let apiRes = await apiCall({ method: "post", url: currentList?.id ? `update-brand` : "store-brand", data: data })
        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
      } catch (error) {
        console.log("Error", error)
        onError(`${error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong"}`)
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout popupStatus={true} className={`${Style.addMeModal} ${Style.leaveModal}`}>
        <div className={`${Style["modal_header"]} ${Style.addMeModal_head}`}>
          <h4>{currentList?.id ? "Update" : "Add"} Brand</h4>
          <div onClick={onClose} className={`${Style["close_btn"]} cursor-pointer`}><XCloseIcon /></div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea}`}>
                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Brand Name</label>
                    {/* <input type="date" placeholder='Type Here' /> */}
                    <input
                      type="text"
                      name='brandName'
                      value={formik.values.brandName}
                      onChange={formik.handleChange}
                      placeholder='Enter Brand Name'
                    />
                    {
                      (formik.touched.brandName && Boolean(formik.errors.brandName)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.brandName && formik.errors.brandName}</span>
                        :
                        null
                    }
                  </div>
                </div>
                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">URL</label>
                    {/* <input type="date" placeholder='Type Here' /> */}
                    <input
                      type="text"
                      name='url'
                      value={formik.values.url}
                      onChange={formik.handleChange}
                      placeholder='Enter URL'
                    />
                    {
                      (formik.touched.url && Boolean(formik.errors.url)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.url && formik.errors.url}</span>
                        :
                        null
                    }
                  </div>
                </div>
                <div className={Style["dcmb__cardBody_formArea_feild"]}>
                  <label htmlFor="">Status</label>
                  <select name='status' value={formik.values.status} onChange={formik.handleChange}>
                    <option value="" disabled>-- Select Status --</option>
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                  {/* { } */}
                  {
                    (formik.touched.status && Boolean(formik.errors.status)) ?
                      <span style={{ color: "red" }} className='ps-1'>{formik.touched.status && formik.errors.status}</span>
                      :
                      null
                  }
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button type='reset' className={`${Style.dcmb__cancel}`} onClick={onClose}>Discard</button>
          <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
        </div>
      </LeftSidePopupLayout>
    </form>
  )
}

export default BrandModal